import React, { useState } from 'react';
import { IoNotificationsOutline, IoCloseOutline } from 'react-icons/io5';
import { QRCodeSVG } from 'qrcode.react';
import { isIOS, isAndroid, isDesktop, APP_STORE_URL } from '../utils/platformDetect';
import { isDismissed, setDismissed, trackEvent } from '../utils/promoTracking';
import { useLanguage } from '../contexts/LanguageContext';
import './AppPromoCard.css';

function AppPromoCard({ stationBusy }) {
  const [dismissed, setDismissedState] = useState(isDismissed('promo_card', 14));
  const [email, setEmail] = useState('');
  const { t } = useLanguage();

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissedState(true);
    setDismissed('promo_card', 14);
    trackEvent('promo-card-dismiss');
  };

  const handleCTA = () => {
    trackEvent('promo-card-click');
    window.open(APP_STORE_URL, '_blank', 'noopener');
  };

  const headline = stationBusy ? t('getAppAlerts') : t('arrivalPrediction');
  const description = stationBusy ? t('getAppAlertsDesc') : t('arrivalPredictionDesc');

  // Android variant
  if (isAndroid()) {
    return (
      <div className="app-promo-card android-variant" role="complementary" aria-label={t('appPromoTitle')}>
        <button className="promo-card-dismiss" onClick={handleDismiss} aria-label="Dismiss">
          <IoCloseOutline size={18} />
        </button>
        <div className="promo-card-content">
          <IoNotificationsOutline size={24} className="promo-card-icon" />
          <div className="promo-card-text">
            <h4>{t('comingSoonAndroid')}</h4>
            <div className="android-email-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('notifyEmail')}
                className="android-email-input"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // iOS + Desktop variant
  return (
    <div className="app-promo-card" role="complementary" aria-label={t('appPromoTitle')}>
      <button className="promo-card-dismiss" onClick={handleDismiss} aria-label="Dismiss">
        <IoCloseOutline size={18} />
      </button>
      <div className="promo-card-content">
        <IoNotificationsOutline size={24} className="promo-card-icon" />
        <div className="promo-card-text">
          <h4>{headline}</h4>
          <p>{description}</p>
          {(isIOS() || !isDesktop()) ? (
            <button className="promo-card-cta" onClick={handleCTA}>
              <img src="/app-store-badge.svg" alt={t('downloadApp')} className="app-store-badge"
                onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'inline'; }}
              />
              <span style={{ display: 'none' }} className="cta-fallback">{t('downloadApp')}</span>
            </button>
          ) : (
            <div className="promo-card-qr">
              <QRCodeSVG value={APP_STORE_URL} size={80} level="M" />
              <span className="qr-label">{t('scanToDownload')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppPromoCard;
